import Vue from 'vue'
import unleashClient from '@/services/unleashClient'

export const FEATURES = Object.freeze({})

const state = Vue.observable({
  flags: {},
  ready: false
})

const watched = new Set()
let bootstrapped = false

function resolveName(featureName) {
  return FEATURES[featureName] || featureName
}

function updateFlags() {
  if (!watched.size) {
    state.ready = true
    return
  }
  for (const flagName of watched) {
    let enabled = false
    try {
      enabled = unleashClient.isEnabled(flagName)
    } catch {}
    Vue.set(state.flags, flagName, enabled)
  }
  state.ready = true
}

if (unleashClient && typeof unleashClient.on === 'function') {
  unleashClient.on('ready', updateFlags)
  unleashClient.on('update', updateFlags)
}

const FeatureToggleService = {
  FEATURES,
  state,
  isReady() {
    return state.ready
  },
  init() {
    if (bootstrapped) return
    Object.values(FEATURES).forEach((flagName) => {
      if (!watched.has(flagName)) watched.add(flagName)
    })
    bootstrapped = true
    updateFlags()
  },
  watch(featureName) {
    const flagName = resolveName(featureName)
    if (!watched.has(flagName)) watched.add(flagName)
    updateFlags()
    return flagName
  },
  getFlag(featureName) {
    const flagName = resolveName(featureName)
    return !!state.flags[flagName]
  }
}

export default FeatureToggleService
